export default __webpack_public_path__ + "static/media/honey_6.efc27b43.png";